var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Button, Card, DatePicker, Divider, Flex, Form, Input, List, Modal, Radio, Select, Space, Spin, Tooltip, Typography, Upload, message } from 'antd';
import { InboxOutlined, MinusCircleOutlined, PlusOutlined, StopOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import certificateService from '../../../services/certificateService';
import { useNavigate, useParams } from 'react-router-dom';
import { DownloadDocument } from '../../../utils/commonUtil';
import { useSelector } from 'react-redux';
import commonService from "../../../services/CommonService";
import { UserActivity } from "../../../config/BVConstants";
const CreateNewCertificate = (props) => {
    var _a, _b, _c, _d, _e;
    const [productModelType, setProductModelType] = useState(1);
    const [form] = Form.useForm();
    const [disableTech, setDisableTech] = useState(true);
    const [checkServiceTypeWireless, setCheckServiceTypeWireless] = useState(false);
    const [certIssueDate, setCertIssueDate] = useState('');
    const [certExpiredDate, setCertExpiredDate] = useState('');
    const { directCertUniqueId } = useParams();
    const [updateCert, setUpdateCert] = useState(false);
    const [directCertUploadDetail, setDirectCertUploadDetail] = useState({});
    const applicationData = useSelector((state) => state.applicationData);
    const [loading, setLoading] = useState(false);
    const customFormat = (value) => `${value.format('DD-MM-YYYY')}`;
    const navigate = useNavigate();
    const boolScreenAccessCheck = ((_d = (_c = (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _a === void 0 ? void 0 : _a.lstClientUserCompanies) === null || _b === void 0 ? void 0 : _b.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _c === void 0 ? void 0 : _c.lstObjLuScreens) === null || _d === void 0 ? void 0 : _d.find((obj) => obj.intId === 3)) != undefined;
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (!((_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _a === void 0 ? void 0 : _a.boolCertificateUploadCertificateFeature) || !boolScreenAccessCheck) {
            navigate('/no-access');
            return;
        }
        if (directCertUniqueId) {
            setUpdateCert(true);
            certificateService
                .getApprCertUploadInfoDetails({ intCertUniqueId: parseInt(atob(directCertUniqueId)) })
                .then((res) => {
                directCertManipulate(res).then((data) => {
                    if (!data.dtCertExpirationDate || isNaN(new Date(data.dtCertExpirationDate).getTime())) {
                        data.dtCertExpirationDate = null;
                    }
                    form.setFieldsValue(data);
                });
            })
                .catch((error) => {
            });
            commonService
                .logUserActivity((_c = (_b = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _b === void 0 ? void 0 : _b.userLoginDetails) === null || _c === void 0 ? void 0 : _c.strUserEmailId, UserActivity.CP__Cert_Upload_Update_Visited);
        }
        else {
            commonService
                .logUserActivity((_e = (_d = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _d === void 0 ? void 0 : _d.userLoginDetails) === null || _e === void 0 ? void 0 : _e.strUserEmailId, UserActivity.CP__Cert_Bulk_Upload_Visited);
            const fieldsValue = form.getFieldValue('objCertificateSeriesBrand') || [];
            if (fieldsValue.length === 0) {
                form.setFieldsValue({
                    objCertificateSeriesBrand: [
                        { default: true, boolDisableRow: true, validate: true },
                        { boolDisableRow: true, validate: true },
                        { boolDisableRow: true, validate: false },
                        { boolDisableRow: true, validate: false },
                        { boolDisableRow: true, validate: false }
                    ]
                });
            }
        }
    }, [form]);
    function directCertManipulate(certData) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            setDirectCertUploadDetail(certData);
            if (certData.boolSingleCertificate) {
                setProductModelType(2);
                certData['objCertificateSeriesBrand'][0].boolDisableRow = true;
                certData['objCertificateSeriesBrand'][0].default = true;
            }
            else {
                setProductModelType(1);
            }
            certData['certUpload'] = [
                {
                    uid: certData === null || certData === void 0 ? void 0 : certData.strDocRefId,
                    name: (_a = certData === null || certData === void 0 ? void 0 : certData.objEEDocument) === null || _a === void 0 ? void 0 : _a.strDocName,
                    status: 'done'
                }
            ];
            certData['dtCertIssueDate'] = dayjs(certData === null || certData === void 0 ? void 0 : certData.dtCertIssueDate, 'DD/MM/YYYY HH:mm:ss');
            certData['dtCertExpirationDate'] = dayjs(certData.dtCertExpirationDate, 'DD/MM/YYYY HH:mm:ss');
            if (certData['objLuServiceCode'] &&
                certData['objLuServiceCode']['intId'] &&
                certData['objLuServiceCode']['intId'] === 100) {
                setDisableTech(false);
            }
            return certData;
        });
    }
    const optSerType = applicationData.serviceTypeList.map((obj) => ({
        label: obj.strLongDesc,
        value: obj.intId
    }));
    const optProdType = applicationData.productTypeList.map((obj) => ({
        label: obj.strLongDesc,
        value: obj.intId
    }));
    const optCountry = applicationData.countryTerritoryList.map((obj) => ({
        label: obj.strLongDesc,
        value: obj.intId
    }));
    const optTechType = applicationData.technologyTypeList.map((obj) => ({
        label: obj.strLongDesc,
        value: obj.intId
    }));
    const onChange = ({ target: { value } }) => {
        setProductModelType(value);
        if (productModelType === 2) {
            form.resetFields();
        }
        else if (productModelType === 1) {
            form.resetFields();
            const fieldsValue = form.getFieldValue('objCertificateSeriesBrand') || [];
            if (fieldsValue.length === 0) {
                form.setFieldsValue({
                    objCertificateSeriesBrand: [
                        { default: true, boolDisableRow: true, validate: true },
                        { boolDisableRow: true, validate: false },
                        { boolDisableRow: true, validate: false },
                        { boolDisableRow: true, validate: false },
                        { boolDisableRow: true, validate: false }
                    ]
                });
            }
        }
    };
    const handleChange = (value) => {
        if (value === 100) {
            setDisableTech(false);
            setCheckServiceTypeWireless(true);
        }
        else {
            setDisableTech(true);
            setCheckServiceTypeWireless(false);
            form.resetFields(['objLuTechnologyType', 'intId']);
            // Clear the validation error for Technology Type field
            form.setFields([
                {
                    name: ['objLuTechnologyType', 'intId'],
                    errors: []
                }
            ]);
        }
    };
    const onChangeExpDate = (date, dateString) => {
        if (date) {
            setCertExpiredDate(date.subtract(1, 'day').format('DD-MM-YYYY'));
        }
        else {
            setCertExpiredDate('');
        }
    };
    const onChangeIssueDate = (date, dateString) => {
        if (date) {
            setCertIssueDate(date.add(1, 'day').format('DD-MM-YYYY'));
        }
        else {
            setCertIssueDate('');
        }
    };
    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e === null || e === void 0 ? void 0 : e.fileList;
    };
    const customRequest = (_a) => __awaiter(void 0, [_a], void 0, function* ({ file, onSuccess, onError }) {
        const formData = new FormData();
        formData.append('file', file);
        try {
            // Simulate a successful response
            setTimeout(() => {
                if (onSuccess) {
                    onSuccess({ status: 'success' });
                }
            }, 10);
        }
        catch (error) {
            if (onError) {
                onError(error);
            }
            message.error('Failed to upload file.');
        }
    });
    const handleUploadRemove = (file) => {
        if (updateCert) {
            certificateService.deleteDocument(file.uid).then((res) => { });
            directCertUploadDetail['strDocRefId'] = undefined;
        }
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(true);
            }, 10);
        });
    };
    const onDownload = (file) => {
        // Example: Trigger a download for a file located at file.url
        if (updateCert) {
            DownloadDocument(file.uid);
        }
        else {
            if (file.url) {
                const a = document.createElement('a');
                a.href = file.url;
                a.download = file.name;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
            else if (file.originFileObj) {
                // If the file is local (not yet uploaded), read it as a Blob
                const reader = new FileReader();
                reader.readAsArrayBuffer(file.originFileObj);
                reader.onload = () => {
                    const blob = new Blob([reader.result]);
                    const a = document.createElement('a');
                    a.href = URL.createObjectURL(blob);
                    a.download = file.name;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(a.href);
                };
            }
        }
    };
    const handleFileChange = (fileList) => {
        const { status } = fileList.file;
        if (status !== 'uploading') {
            fileList.status = 'done';
            message.success(`${fileList.file.name} ${fileList.file.status} file uploaded successfully.`);
        }
    };
    const onFieldChange = (fieldName, value) => {
        const objCertificateSeriesBrand = form.getFieldValue('objCertificateSeriesBrand') || [];
        if (fieldName === 'objBrandName') {
            objCertificateSeriesBrand[0]['objBrandName'] = { strLongDesc: value };
        }
        else if (fieldName === 'strProductModel') {
            objCertificateSeriesBrand[0]['strSeriesModal'] = value;
        }
        if (objCertificateSeriesBrand[0]['objBrandName'] &&
            objCertificateSeriesBrand[0]['strSeriesModal']) {
            objCertificateSeriesBrand[1]['boolDisableRow'] = false;
        }
        form.setFieldsValue({ objCertificateSeriesBrand });
    };
    const onPfFieldChange = (rowIndex, fieldName, value) => {
        const objCertificateSeriesBrand = form.getFieldValue('objCertificateSeriesBrand') || [];
        objCertificateSeriesBrand[rowIndex]['validate'] = true;
        if (objCertificateSeriesBrand[rowIndex]['objBrandName'] &&
            objCertificateSeriesBrand[rowIndex]['strSeriesModal']) {
            if (objCertificateSeriesBrand[rowIndex + 1]) {
                objCertificateSeriesBrand[rowIndex + 1]['boolDisableRow'] = false;
            }
        }
        form.setFieldsValue({ objCertificateSeriesBrand });
    };
    function formatDateValue(date) {
        if (date === null || date.getFullYear() === 1970) {
            return null;
        }
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
            .toString()
            .padStart(2, '0')}/${date.getFullYear()} ${date
            .getHours()
            .toString()
            .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date
            .getSeconds()
            .toString()
            .padStart(2, '0')}`;
        return formattedDate;
    }
    const onFinish = (values) => {
        var _a, _b;
        setLoading(true);
        const objCreateNewCert = {
            objCreatedBy: { objUser: { intId: (_b = (_a = applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID } }
        };
        const objCert = JSON.parse(JSON.stringify(values));
        delete objCert.certUpload;
        if (productModelType === 2) {
            // objCert["objCertificateSeriesBrand"] = lstProductFamily;
            objCert['intSingleCertificate'] = 1;
            objCreateNewCert['intSingleCertificate'] = 1;
        }
        else {
            objCert['intSingleCertificate'] = 0;
            objCreateNewCert['intSingleCertificate'] = 0;
        }
        if (values.dtCertIssueDate) {
            objCert['dtCertIssueDate'] = formatDateValue(new Date(values.dtCertIssueDate));
        }
        if (values.dtCertExpirationDate) {
            objCert['dtCertExpirationDate'] = values.dtCertExpirationDate ? formatDateValue(new Date(values.dtCertExpirationDate)) : null;
        }
        const formData = new FormData();
        formData.append('file', values.certUpload[0].originFileObj);
        formData.append('strPathType', 'DIRECT_CERT_UPLOAD');
        if (updateCert) {
            objCreateNewCert['strRefId'] = directCertUploadDetail['strRefId'];
            objCert['intCertUniqueId'] = directCertUploadDetail['intCertUniqueId'];
            objCert['objLuRequestType'] = directCertUploadDetail['objLuRequestType'];
            objCert['objCertRenewalStatus'] = directCertUploadDetail['objCertRenewalStatus'];
            objCert['objLuCertVerification'] = directCertUploadDetail['objLuCertVerification'];
            if (!values.certUpload[0].originFileObj) {
                objCert['strDocRefId'] = directCertUploadDetail['strDocRefId'];
                objCreateNewCert['lstNewCertificateUploadClient'] = [objCert];
                certificateService.saveClientCertUpload(objCreateNewCert).then((res) => {
                    setLoading(false);
                    message.success('Certificate Saved successfully. Reference ID:' + (res === null || res === void 0 ? void 0 : res.strRefId));
                });
            }
            else {
                certificateService.saveDocument(formData).then((res) => {
                    objCert['strDocRefId'] = res;
                    objCreateNewCert['lstNewCertificateUploadClient'] = [objCert];
                    certificateService.saveClientCertUpload(objCreateNewCert).then((res) => {
                        var _a, _b;
                        setLoading(false);
                        commonService
                            .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Cert_Create_New_Created);
                        message.success('Certificate Saved successfully. Reference ID:' + (res === null || res === void 0 ? void 0 : res.strRefId));
                    });
                }).catch((error) => {
                    var _a;
                    console.log(error);
                    setLoading(false);
                    message.error((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data);
                });
            }
        }
        else {
            objCert['strAction'] = 'NEW';
            objCert['objLuRequestType'] = {
                intId: 1
            };
            certificateService.saveDocument(formData).then((res) => {
                var _a, _b;
                objCert['strDocRefId'] = res;
                objCreateNewCert['lstNewCertificateUploadClient'] = [objCert];
                certificateService.saveClientCertUpload(objCreateNewCert).then((res) => {
                    setLoading(false);
                    CertUploadSuccess(res);
                });
                commonService
                    .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Cert_Upload_Updated);
            }).catch((error) => {
                var _a;
                setLoading(false);
                message.error((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data);
            });
        }
    };
    const handleRedirectCertificate = (objDirectCertificate) => {
        var _a;
        const uniqueCertificateId = (_a = objDirectCertificate === null || objDirectCertificate === void 0 ? void 0 : objDirectCertificate.lstNewCertificateUploadClient[0]) === null || _a === void 0 ? void 0 : _a.intCertUniqueId;
        if (uniqueCertificateId) {
            const url = `/certificates/details/${btoa(uniqueCertificateId.toString())}`;
            navigate(url);
        }
    };
    const CertUploadSuccess = (objDirectCertificate) => {
        Modal.success({
            title: 'Certificates uploaded successfully.',
            centered: true,
            content: _jsxs(_Fragment, { children: ["Reference ID: ", objDirectCertificate === null || objDirectCertificate === void 0 ? void 0 : objDirectCertificate.strRefId] }),
            onOk() {
                handleRedirectCertificate(objDirectCertificate);
            }
        });
    };
    const redirectBulkUpload = () => {
        navigate('/certificates/upload-new-certificate');
    };
    const disabledStyle = {
        color: 'blue',
        cursor: 'not-allowed',
        opacity: 0.2
    };
    return (_jsx(Card, { style: { borderRadius: '0px' }, title: updateCert ? 'Update Certificate Information' : 'Add New Certificates', extra: updateCert || (_jsxs(Space, { size: [100, 0], wrap: true, children: [_jsxs(Radio.Group, { onChange: onChange, value: productModelType, children: [_jsx(Radio, { value: 1, children: "Upload Single Certificate for One Product Model" }), _jsx(Radio, { value: 2, children: "Upload Single Certificate for Multiple Product Model" })] }), ((_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _e === void 0 ? void 0 : _e.boolCertificateUploadCertificateFeature) ? (_jsx(Typography.Link, { onClick: () => redirectBulkUpload(), strong: true, children: "Bulk Upload" })) : (_jsx(_Fragment, { children: _jsx(Tooltip, { title: "Please Upgrade Membership.", children: _jsx("span", { style: disabledStyle, children: "Bulk Upload" }) }) }))] })), children: _jsx(Spin, { size: "default", spinning: loading, tip: "Loading", children: _jsxs(Form, { form: form, layout: "vertical", name: "Certificate-form", onFinish: onFinish, children: [_jsx(Typography.Title, { level: 5, children: "Product Information" }), _jsx(Flex, { wrap: "wrap", justify: 'flex-start', align: 'flex-start', children: _jsxs(Space, { size: [55, 4], wrap: true, children: [_jsx(Form.Item, { name: 'strProductName', label: 'Product Name', rules: [
                                        {
                                            required: true,
                                            message: 'Product Name is Required'
                                        }
                                    ], children: _jsx(Input, { style: { width: 250 }, placeholder: "Product Name" }) }), _jsx(Form.Item, { name: 'strProductModel', label: 'Product Model', rules: [
                                        {
                                            required: true,
                                            message: 'Product Modal is Required'
                                        }
                                    ], children: _jsx(Input, { style: { width: 250 }, placeholder: "Product Model", onChange: (e) => onFieldChange('strProductModel', e.target.value) }) }), _jsx(Form.Item, { name: ['objBrandName', 'strLongDesc'], label: 'Brand/OEM', rules: [
                                        {
                                            required: true,
                                            message: 'Brand/OEM is Required'
                                        }
                                    ], children: _jsx(Input, { style: { width: 250 }, placeholder: "Brand/OEM", onChange: (e) => onFieldChange('objBrandName', e.target.value) }) }), _jsx(Form.Item, { name: ['objLuCountry', 'intId'], label: 'Country', rules: [
                                        {
                                            required: true,
                                            message: 'Country/Territory is Required'
                                        }
                                    ], children: _jsx(Select, { showSearch: true, filterOption: (input, option) => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, style: { width: 250 }, placeholder: "Country/Territory", options: optCountry }) }), _jsx(Form.Item, { name: ['objLuServiceCode', 'intId'], label: 'Service Type', rules: [
                                        {
                                            required: true,
                                            message: 'Service Type is Required'
                                        }
                                    ], children: _jsx(Select, { showSearch: true, filterOption: (input, option) => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, onChange: handleChange, style: { width: 250 }, placeholder: "Service Type", options: optSerType }) }), _jsx(Form.Item, { name: ['objLuProductType', 'intId'], label: 'Product Sub Segment', rules: [
                                        {
                                            required: true,
                                            message: 'Product Sub Segment is Required'
                                        }
                                    ], children: _jsx(Select, { showSearch: true, filterOption: (input, option) => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, style: { width: 250 }, placeholder: "Product Sub Segment", options: optProdType }) }), _jsx(Form.Item, { name: ['objLuTechnologyType', 'intId'], label: 'Technology Type', rules: [
                                        { required: checkServiceTypeWireless, message: 'Technology Type is Required' }
                                    ], children: _jsx(Select, { showSearch: true, filterOption: (input, option) => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, style: { width: 250 }, placeholder: "Technology Type", disabled: disableTech, options: optTechType }) })] }) }), _jsx(Divider, {}), _jsx(Typography.Title, { level: 5, children: "Certificate Information" }), _jsx(Flex, { wrap: "wrap", justify: 'flex-start', align: 'flex-start', children: _jsxs(Space, { size: [55, 4], wrap: true, children: [_jsx(Form.Item, { name: 'strCertId', label: 'Certificate Id', rules: [
                                        {
                                            required: true,
                                            message: 'Certificate Id is Required'
                                        }
                                    ], children: _jsx(Input, { style: { width: 250 }, placeholder: "Certificate Id" }) }), _jsx(Form.Item, { name: 'dtCertIssueDate', label: 'Certificate Issue Date', rules: [
                                        {
                                            required: true,
                                            message: 'Certificate Issue Date'
                                        }
                                    ], children: _jsx(DatePicker, { style: { width: 250 }, format: customFormat, onChange: onChangeIssueDate, multiple: false, maxDate: dayjs(certExpiredDate, 'DD-MM-YYYY') }) }), _jsx(Form.Item, { name: 'dtCertExpirationDate', label: 'Certificate Expiration Date', children: _jsx(DatePicker, { style: { width: 250 }, format: customFormat, multiple: false, onChange: onChangeExpDate, minDate: dayjs(certIssueDate, 'DD-MM-YYYY') }) })] }) }), _jsx(Divider, {}), _jsx(Typography.Title, { level: 5, children: "Document Upload" }), _jsx(Flex, { wrap: "wrap", justify: 'flex-start', align: 'flex-start', children: _jsx(Space, { size: [55, 4], wrap: true, children: _jsx(Form.Item, { label: 'Certificate Upload', name: "certUpload", valuePropName: "fileList", getValueFromEvent: normFile, rules: [
                                    {
                                        required: true,
                                        message: 'Certificate is Required'
                                    }
                                ], children: _jsxs(Upload.Dragger, { name: "files", accept: 'application/pdf,application/x-zip-compressed', maxCount: 1, onChange: handleFileChange, customRequest: customRequest, showUploadList: { showDownloadIcon: true }, onDownload: onDownload, onRemove: handleUploadRemove, children: [_jsx("p", { className: "ant-upload-drag-icon", children: _jsx(InboxOutlined, {}) }), _jsx("p", { className: "ant-upload-text", children: "Click or drag file to this area to upload" }), _jsx("p", { className: "ant-upload-hint", children: "Support for a single upload." })] }) }) }) }), productModelType === 2 && (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx(Typography.Title, { level: 5, children: "Series Model Information" }), _jsx(Flex, { wrap: "wrap", justify: 'flex-start', align: 'flex-start', children: _jsx(Form.List, { name: "objCertificateSeriesBrand", children: (fields, { add, remove }) => (_jsxs(_Fragment, { children: [_jsx(Form.Item, { children: _jsx(Button, { type: "dashed", onClick: () => add(), block: true, icon: _jsx(PlusOutlined, {}), style: { width: '100%' }, children: "Add field" }) }), _jsx(List, { itemLayout: "vertical", dataSource: fields, pagination: {
                                                    onChange: (page) => {
                                                    },
                                                    pageSize: 5,
                                                    align: 'start'
                                                }, grid: {
                                                    gutter: 16,
                                                    xs: 1,
                                                    sm: 1,
                                                    md: 1,
                                                    lg: 1,
                                                    xl: 1,
                                                    xxl: 1
                                                }, renderItem: (_a) => {
                                                    var { key, name } = _a, restField = __rest(_a, ["key", "name"]);
                                                    const boolDisableRow = form.getFieldValue([
                                                        'objCertificateSeriesBrand',
                                                        name,
                                                        'boolDisableRow'
                                                    ]);
                                                    const boolDefault = form.getFieldValue([
                                                        'objCertificateSeriesBrand',
                                                        name,
                                                        'default'
                                                    ]);
                                                    return (_jsx(List.Item, { children: _jsxs(Space, { style: { display: 'flex', marginBottom: 2 }, align: "baseline", children: [!boolDefault ? (_jsx(MinusCircleOutlined, { onClick: () => remove(name) })) : (_jsx(StopOutlined, {})), _jsxs(Space, { size: [20, 4], wrap: true, children: [_jsx(Form.Item, Object.assign({}, restField, { name: [name, 'objBrandName', 'strLongDesc'], rules: [
                                                                                {
                                                                                    required: form.getFieldValue([
                                                                                        'objCertificateSeriesBrand',
                                                                                        name,
                                                                                        'validate'
                                                                                    ]),
                                                                                    message: 'Missing Brand Name'
                                                                                }
                                                                            ], children: _jsx(Input, { style: { width: 250 }, onChange: (e) => onPfFieldChange(name, 'objBrandName', e.target.value), placeholder: "Brand Name", disabled: boolDisableRow }) })), _jsx(Form.Item, Object.assign({}, restField, { name: [name, 'strSeriesModal'], rules: [
                                                                                {
                                                                                    required: form.getFieldValue([
                                                                                        'objCertificateSeriesBrand',
                                                                                        name,
                                                                                        'validate'
                                                                                    ]),
                                                                                    message: 'Missing Series Modal'
                                                                                }
                                                                            ], children: _jsx(Input, { style: { width: 250 }, onChange: (e) => onPfFieldChange(name, 'strSeriesModel', e.target.value), placeholder: "Series Modal", disabled: boolDisableRow }) }))] })] }, key) }));
                                                } })] })) }) })] })), _jsx(Form.Item, { children: _jsx("div", { style: { textAlign: 'center', marginTop: '15px' }, children: _jsx(Button, { type: "primary", htmlType: "submit", children: updateCert ? 'Save Changes' : 'Submit' }) }) })] }) }) }));
};
export default CreateNewCertificate;
